import { FC, Suspense } from 'react'

import { Outlet } from '@tanstack/react-router'

import { ReportsSocket } from './api/ReportsSocket'
import { ReportWebsocketContextProvider } from './api/ReportWebsocketContextProvider'

export const ReportWebsocketRoute: FC = () => {
  return (
    <ReportWebsocketContextProvider>
      {/*TODO add local error boundary, though report download is broken if the socket is down
       */}
      <Suspense>
        <ReportsSocket />
      </Suspense>
      <Outlet />
    </ReportWebsocketContextProvider>
  )
}
